import { useState } from "react";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { API_BASE_URL } from "../creds";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        try {
            const response = await axios.post(`${API_BASE_URL}/login`, { email, password });
            console.log("Login:", response.data)
            if (response.data && response.status === 200) {
                setSuccess(response.data.message)
            };
            if (response.data.role === "Admin") {
                localStorage.setItem("userLogin", JSON.stringify(response.data));
                navigate("/admin");
            } else {
                navigate("/");
            }
        } catch (err) {
            setError("Invalid email or password");
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen px-4">
        <form
            onSubmit={handleSubmit}
            className="bg-white p-8 rounded-lg shadow-lg w-[400px] px-10 max-w-md transition-shadow duration-300 hover:shadow-xl"
        >
            <h3 className="text-3xl font-semibold text-center mb-6">Login</h3>

            {error && (
                <div className="bg-red-100 text-red-700 text-sm rounded p-2 mb-4">
                    {error}
                </div>
            )}
            {success && (
                <div className="bg-green-100 text-green-700 text-sm rounded p-2 mb-4">
                    {success}
                </div>
            )}

            <div className="mb-5">
                <label className="block text-lg font-medium mb-2">Email</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full border border-gray-300 rounded px-4 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </div>

            <div className="mb-6">
                <label className="block text-lg font-medium mb-2">Password</label>
                <div className="relative">
                    <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="w-full border border-gray-300 rounded px-4 py-2 text-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                    />
                    <span
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                    </span>
                </div>
            </div>

            <button
                type="submit"
                className="w-full bg-blue-600 text-white py-3 rounded-lg mb-5 hover:bg-blue-700 transition-colors text-lg font-medium"
            >
                Login
            </button>
        </form>
    </div>
);
};

export default Login;